<template>
  <div class="">
    <v-menu></v-menu>
    <v-cover></v-cover>
    <v-streak></v-streak>
    <v-info class=""></v-info>
    <v-cards></v-cards>
    <v-carousel></v-carousel>
    <v-map></v-map>
    <!-- <v-parallax></v-parallax> -->

    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <div id="contact" class="footer-copyright text-center py-3 bg-info mt-5">
      <mdb-container fluid class="text-white">
        &copy; {{ new Date().getFullYear() }} Copyright:
        <a class="text-white" href="imprentalasamericas1@yahoo.com">
          Imprenta Las Americas
        </a>
        <p class="mb-1">
          Web Development by:
          <a class="text-white" target="_blank" href="http://www.rivforpr.com">
            RivFor
          </a>
        </p>
      </mdb-container>
    </div>
    <v-login></v-login>
    <v-estimate></v-estimate>
  </div>
</template>

<script>
// @ is an alias to /src

import { mdbContainer } from "mdbvue";
export default {
  name: "Home",
  components: {
    mdbContainer,
  },
};
</script>

<style lang="css">
/* Extra small devices (portrait phones, less than 576px) */
/* No media query since this is the default in Bootstrap */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .container {
    /* margin-left: 10px;
      margin-right: 10px; */
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  #socialNav {
    flex: none !important;
    text-align: center !important;
    /* justify-content: none !important; */
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .navbar-nav {
    margin-left: 200px !important;
  }
}
</style>
